import NoResults from "components/Blocks/NoResults/NoResults";

export default NoResults;
